import React, { useState } from 'react';
import './InputPromptDialog.css';

const InputPromptDialog = ({ 
  message, 
  onConfirm, 
  onCancel, 
  inputPlaceholder = 'Enter text...' 
}) => {
  const [inputValue, setInputValue] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm(inputValue);
  };

  return (
    <div className="input-prompt-overlay" onClick={onCancel}>
      <div className="input-prompt-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="input-prompt-header">
          Input Required
        </div>
        <form onSubmit={handleSubmit}>
          <div className="input-prompt-body">
            <p className="input-prompt-message">{message}</p>
            <input
              type="text"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              placeholder={inputPlaceholder}
              autoFocus
              className="input-prompt-field"
            />
          </div>
          <div className="input-prompt-footer">
            <button type="button" onClick={onCancel} className="input-prompt-btn-cancel">
              Cancel
            </button>
            <button type="submit" className="input-prompt-btn-confirm">
              Confirm
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default InputPromptDialog;